import { useEffect } from 'react';

/**
 * Public route — hard-redirects to the external Dubai landing page.
 * No auth required. Accessible via both /Dubai and /dubai.
 */
export default function DubaiRedirect() {
  useEffect(() => {
    window.location.replace('https://kilobeatdub-mtknte53.manus.space');
  }, []);

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-orange-500 mx-auto mb-4"></div>
        <p className="text-sm text-gray-600">Redirecting you to KiloBeaters Dubai…</p>
        <p className="text-xs text-gray-400 mt-2">
          If you are not redirected,{' '}
          <a
            href="https://kilobeatdub-mtknte53.manus.space"
            className="text-orange-600 underline"
          >
            click here
          </a>
          .
        </p>
      </div>
    </div>
  );
}
